import { GetSelfAssessment } from "__generated__/types";
import { ElementPage } from "domain/pages/ElementPage";
import gql from "graphql-tag";
import React from "react";
import { useParams } from "react-router";

export const selfAssessmentFragment = gql`
  fragment SelfAssessmentFragment on SelfAssessment {
    id
    title
    originFolderId
    originFolderParentId
    status
    articles {
      id
      content {
        id
        title
        status
        context {
          id
          title
        }
        body {
          content
          isMarkdown
        }
        youtubeVideoId
        canUpdateDetails {
          canPerform
        }
        canCreateProgression {
          canPerform
        }
      }
    }
    multipleChoiceExercises {
      id
      content {
        type
        id
        title
        status
        context {
          id
          title
        }
        canUpdateDetails {
          canPerform
        }
        canCreateProgression {
          canPerform
        }
        questions {
          id
          title
          body {
            content
            isMarkdown
          }
          options {
            id
            title
            correct
          }
        }
      }
    }
    delivery {
      deliveredAt
      score {
        factorPercent
      }
    }
  }
`;

const DATA_QUERY = gql`
  query GetSelfAssessment($containerId: ID!) {
    selfAssessmentById(id: $containerId) {
      ...SelfAssessmentFragment
    }
  }
  ${selfAssessmentFragment}
`;

type RouteProps = {
  selfAssessmentId: string;
  selfAssessmentElementId: string;
};

export const SelfAssessmentElementPage: React.FC = () => {
  const { selfAssessmentId, selfAssessmentElementId } = useParams<RouteProps>();

  if (!selfAssessmentId) {
    throw new Error("Unexpected error: Missing selfAssessmentId");
  }

  if (!selfAssessmentElementId) {
    throw new Error("Unexpected error: Missing selfAssessmentElementId");
  }

  return (
    <ElementPage<GetSelfAssessment>
      containerId={selfAssessmentId}
      query={DATA_QUERY}
      elementId={selfAssessmentElementId}
      containerType="SelfAssessment"
      getData={(it) => {
        const { articles, multipleChoiceExercises, ...rest } =
          it.selfAssessmentById ?? {};
        return {
          ...rest,
          title: it.selfAssessmentById?.title ?? "Selvtest",
          canUpdateDetails: {
            canPerform: false,
          },
          elements: [
            ...(articles ?? []),
            ...(multipleChoiceExercises ?? []),
          ].map((el) => ({
            id: el.id,
            content: el.content,
          })),
        };
      }}
    />
  );
};
